"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductType = void 0;
var ProductType;
(function (ProductType) {
    ProductType[ProductType["Software Module"] = 0] = "Software Module";
    ProductType[ProductType["Software Feature"] = 1] = "Software Feature";
    ProductType[ProductType["Kit+Fulfillment"] = 2] = "Kit+Fulfillment";
    ProductType[ProductType["Kit+Fulfillment+Testing+Results"] = 3] = "Kit+Fulfillment+Testing+Results";
    ProductType[ProductType["Kit+Product+Fulfillment"] = 4] = "Kit+Product+Fulfillment";
    ProductType[ProductType["Kit+Fulfillment+Testing+Lab Coord"] = 5] = "Kit+Fulfillment+Testing+Lab Coord";
    ProductType[ProductType["Testing+Lab Coord+Results"] = 6] = "Testing+Lab Coord+Results";
    ProductType[ProductType["Program Services"] = 7] = "Program Services";
    ProductType[ProductType["Software Services"] = 8] = "Software Services";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
//# sourceMappingURL=ProductType.js.map